export class ResumeParsingStatusModel {
  state: string;
  resumeWasUploaded: boolean;
}
